import { render, staticRenderFns } from "./UserAccessRestriction.vue?vue&type=template&id=47a34fdc&scoped=true"
import script from "./UserAccessRestriction.vue?vue&type=script&lang=js"
export * from "./UserAccessRestriction.vue?vue&type=script&lang=js"
import style0 from "./UserAccessRestriction.vue?vue&type=style&index=0&id=47a34fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a34fdc",
  null
  
)

export default component.exports